import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Region} from '../pushpin-map/angular-bing-maps/region.class';
import {Pushpin} from '../../classes/pushpin.class';
import {CustomerArea} from '../../classes/customerarea.class';
import {Inspection} from '../../classes/inspection';
import {InspectionService} from '../../services/inspection.service';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {PushpinPart} from '../../classes/pushpinpart.class';
import {PushpinMapComponent} from '../pushpin-map/pushpin-map.component';

@Component({
    selector: 'app-pushpin-move',
    templateUrl: './pushpin-move.component.html',
    styleUrls: ['./pushpin-move.component.scss']
})
export class PushpinMoveComponent implements OnInit {

    @HostBinding('class')
    classList = '';

    visible = false;

    @Input()
    customerArea!: CustomerArea;

    @Input()
    mapComponent: PushpinMapComponent;

    @Output()
    pushpinsMoved = new EventEmitter();

    pushpins: Pushpin[];
    selectedPushpins: Pushpin[];
    selectedPushpinParts: PushpinPart[];
    moveToInspection: Inspection;
    possibleInspectionIds: number[];

    moving = false;
    copying = false;

    inspections: Inspection[];

    selectionEnabled = false;

    constructor(private inspectionService: InspectionService,
                private confirmDialogService: ConfirmDialogService) {
    }

    ngOnInit(): void {
    }

    toggle() {
        this.visible = !this.visible;
        this.classList = this.visible ? 'visible' : '';
        this.inspections = this.customerArea.inspections;
    }

    inspectionChanged() {
        this.possibleInspectionIds = this.customerArea.inspections
            .filter(i => i.inspection_type_id === this.moveToInspection.inspection_type_id)
            .map(i => i.id);
        this.getIncludedParts();
    }

    clearSelection() {
        this.mapComponent.selectionPolygon = null;
        this.selectionEnabled = false;
    }

    draw() {
        this.selectionEnabled = true;
    }

    setVisiblePushpins(pushpins: Pushpin[]) {
        this.pushpins = pushpins;
    }

    movePoints() {
        this.moving = true;
        this.confirmDialogService.confirm(
            'Punten in selectie verplaatsen naar schouwronde',
            `Weet u zeker dat alle ${this.selectedPushpins.length} punten in de selectie wilt verplaatsen naar schouwronde ${this.moveToInspection.name}?`,
            'Verplaatsen',
            'Annuleren').then(() => {
            this.inspectionService.changeInspectionOfParts(this.moveToInspection.id, this.selectedPushpinParts.map(p => p.id)).subscribe(() => {
                this.clearSelection();
                this.pushpinsMoved.emit();
                this.moving = false;
            }, () => {
                this.moving = false;
            });
        }, () => {
            this.moving = false;
        });
    }

    copyPoints() {
        this.copying = true;
        this.confirmDialogService.confirm(
            'Punten in selectie kopiëren naar schouwronde',
            `Weet u zeker dat alle ${this.selectedPushpins.length} punten in de selectie wilt kopiëren naar schouwronde ${this.moveToInspection.name}?`,
            'Kopieer',
            'Annuleren').then(() => {
            this.inspectionService.copyPartToInspection(this.moveToInspection.id, this.selectedPushpinParts.map(p => p.id)).subscribe(() => {
                this.clearSelection();
                this.pushpinsMoved.emit();
                this.copying = false;
            }, () => {
                this.copying = false;
            });
        }, () => {
            this.copying = false;
        });
    }

    public getIncludedParts() {
        if (this.mapComponent.selectionPolygon?.length > 2) {
            const manualRegion = new Region(this.mapComponent.selectionPolygon);
            if (manualRegion) {
                this.selectedPushpins = this.pushpins?.filter(pushpin => manualRegion.insideTown({lat: pushpin.lat, lng: pushpin.lng}));
                this.selectedPushpinParts = [].concat.apply([], this.selectedPushpins.map(p => p.pushpin_parts))
                    .filter(pp => this.possibleInspectionIds.indexOf(pp.inspection_id) !== -1);
            }
        }
    }
}
